/**
 * Visit Tracker
 * Отслеживает количество визитов пользователя до регистрации
 */

const VISIT_COUNT_KEY = 'astrobaby_visit_count';
const getCurrentVisitKey = () => `${VISIT_COUNT_KEY}_${new Date().toDateString()}`;

/**
 * Отслеживает новый визит пользователя
 * @returns номер визита по счету
 */
export function trackVisit(): number {
  if (typeof window === 'undefined') {
    return 1;
  }

  try {
    const todayKey = getCurrentVisitKey();
    const todayVisit = localStorage.getItem(todayKey);
    
    // Если сегодня уже был визит, возвращаем общий счетчик
    if (todayVisit === 'visited') {
      const count = getTotalVisitCount();
      return count;
    }

    // Первый визит сегодня - увеличиваем счетчик
    const newCount = incrementVisitCount();
    
    // Помечаем сегодняшний визит
    localStorage.setItem(todayKey, 'visited');
    
    console.log(`📊 Visit #${newCount} tracked`);
    return newCount;
  } catch (error) {
    console.error('Failed to track visit:', error);
    return 1;
  }
}

/**
 * Получает общее количество визитов
 */
function getTotalVisitCount(): number {
  try {
    const count = localStorage.getItem(VISIT_COUNT_KEY);
    return count ? parseInt(count, 10) : 0;
  } catch (error) {
    console.error('Failed to get visit count:', error);
    return 0;
  }
}

/**
 * Увеличивает счетчик визитов
 */
function incrementVisitCount(): number {
  try {
    const currentCount = getTotalVisitCount();
    const newCount = currentCount + 1;
    localStorage.setItem(VISIT_COUNT_KEY, newCount.toString());
    return newCount;
  } catch (error) {
    console.error('Failed to increment visit count:', error);
    return 1;
  }
}

/**
 * Сбрасывает счетчик визитов (например, после регистрации)
 */
export function resetVisitCount(): void {
  try {
    localStorage.removeItem(VISIT_COUNT_KEY);
    localStorage.removeItem(getCurrentVisitKey());
    console.log('📊 Visit count reset');
  } catch (error) {
    console.error('Failed to reset visit count:', error);
  }
}

/**
 * Получает текущее количество визитов без инкремента
 */
export function getVisitCount(): number {
  return getTotalVisitCount();
}

